import { ArticleSearchCategory } from './categories';

export enum TIMEFRAMES {
	WEEKLY = 'weekly',
	MONTHLY = 'monthly',
}

export enum METRICS {
	HENI_SCORE = 'heniScore',
	MARKET_SALES = 'marketSales',
	HENI_MENTIONS = 'heniMentions',
	HENI_NFT_MENTIONS = 'heniNftMentions',
	HENI_SHOWS_MENTIONS = 'heniShowsMentions',
	HENI_PROFILE_MENTIONS = 'heniProfileMentions',
}

export const CATEGORY_METRICS_MAP = Object.freeze({
	[METRICS.MARKET_SALES]: { category: ArticleSearchCategory.market },
	[METRICS.HENI_MENTIONS]: {},
	[METRICS.HENI_NFT_MENTIONS]: {},
	[METRICS.HENI_SCORE]: {},
	[METRICS.HENI_SHOWS_MENTIONS]: { category: ArticleSearchCategory.shows },
	[METRICS.HENI_PROFILE_MENTIONS]: {},
});
